import { LoadingIndicator } from '../../shared/ui/loading';
import './map-page-skeleton.css';

/** Uses the real workspace grid without importing or starting the renderer. */
export function MapPageSkeleton() {
  return (
    <div
      className="workspace workspace--library-open map-page-skeleton"
      aria-busy="true"
      aria-label="Đang mở bản đồ"
    >
      <header className="app-header" aria-hidden="true">
        <div className="map-skeleton-brand">
          <span className="loading-block" />
          <span className="loading-block" />
        </div>
        <div className="map-skeleton-account">
          <span className="loading-block" />
          <span className="loading-block" />
        </div>
      </header>
      <aside className="map-skeleton-sidebar" aria-hidden="true">
        <div className="map-skeleton-tabs">
          <span className="loading-block" />
          <span className="loading-block" />
        </div>
        <span className="loading-block map-skeleton-input" />
        {Array.from({ length: 6 }, (_, i) => (
          <div className="map-skeleton-item" key={i}>
            <span className="loading-block" />
            <span className="loading-block" />
            <span className="loading-block" />
          </div>
        ))}
      </aside>
      <main className="map-workspace">
        <div className="map-skeleton-tools" aria-hidden="true">
          <div className="map-skeleton-search">
            <span className="loading-block" />
          </div>
          <div className="map-skeleton-toolbar">
            {Array.from({ length: 4 }, (_, i) => (
              <span key={i} className="loading-block" />
            ))}
          </div>
        </div>
        <div className="map-skeleton-status">
          <LoadingIndicator label="Đang mở bản đồ và mô hình…" />
        </div>
        <div className="map-skeleton-navigation" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <span className="loading-block" key={i} />
          ))}
        </div>
        <div className="map-skeleton-basemap" aria-hidden="true">
          <span className="loading-block" />
        </div>
      </main>
    </div>
  );
}
